var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.24996H3.16667M3.16667 4.24996H16.5M3.16667 4.24996V15.9166C3.16667 16.3587 3.34226 16.7826 3.65482 17.0951C3.96738 17.4077 4.39131 17.5833 4.83333 17.5833H13.1667C13.6087 17.5833 14.0326 17.4077 14.3452 17.0951C14.6577 16.7826 14.8333 16.3587 14.8333 15.9166V4.24996H3.16667ZM5.66667 4.24996V2.58329C5.66667 2.14127 5.84226 1.71734 6.15482 1.40478C6.46738 1.09222 6.89131 0.916626 7.33333 0.916626H10.6667C11.1087 0.916626 11.5326 1.09222 11.8452 1.40478C12.1577 1.71734 12.3333 2.14127 12.3333 2.58329V4.24996M7.33333 8.41663V13.4166M10.6667 8.41663V13.4166",
    stroke: "#A1A1A1",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.e7b2a51b5b362a6bbf79dd73b5c3ce66.svg";
export { ForwardRef as ReactComponent };